/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const ikigai: CommunityData = {
  code: "ikigai",
  name: "Ikigai",
  thumbnail: "/assets/customizations/ikigai/ikigai-thumbnail.png",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/iki-113`,
  socials: {
    instagramLink: "https://www.instagram.com/ikigaiandmusic/",
    soundcloudLink: "https://soundcloud.com/ikigaiandmusic",
    youtubeLink: "https://www.youtube.com/channel/UCN-yjTYd_qli8NwYNi4sRyg",
  },
  styles: {
    global: {
      counterColor: "#7659BA",
      alternativeLogo: {
        src: "/assets/customizations/ikigai/logo-white.svg",
        styles: "w-[161px]",
      },
      logo: {
        src: "/assets/customizations/ikigai/logo.svg",
        styles: "w-[264px] h-[80px] object-contain",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#261e1e",
      asideStyles: "",
      asideBg: "#7659BA",
      contentBg: "#F3EDF4",
      contentBoxShadow: "shadow-[0px_4px_4px_rgba(0,0,0,0.25)]",
      bgDesktop: "/assets/customizations/ikigai/ikigai-bg.png",
      bgMobile: "/assets/customizations/ikigai/ikigai-bg.png",
      nonMemberBg: "/assets/customizations/ikigai/ikigai-bg.png",
      mainFont: "font-['HelveticaNeue']",
      primaryButton:
        "w-full sm:w-fit !h-12 bg-black border-[3px] border-[#9773E1] !px-[30px] !text-base !leading-[1] font-['Microgramma'] !text-white whitespace-nowrap uppercase",
    },
    navigation: {
      sideBarSeparator: "",
      iconsColor: "#FFFFFF",
      separator: "border-[#DBCCDE] border-t",
      item: "font-['Microgramma'] text-[18px] leading-[18px] h-[40px] flex items-center sm:justify-start justify-center uppercase text-[#FFFFFF] !pt-1",
      itemSelected: "bg-[#977BD7] text-[#FFFFFF]",
    },
    communityLanding: {
      emptyOrLoadingState: "",
      titles: "font-['Microgramma'] uppercase text-black text-[24px] leading-6 pb-2",
      announcements: {
        customBg: "bg-[#000000]",
        lg: {
          title: "text-base sm:text-[22px] leading-[1] font-['Microgramma'] mb-1",
          subtitle: "text-[11px] leading-[1] font-bold !text-[#DBCCDE]",
        },
        sm: {
          title: "text-base sm:text-[12px] leading-[1] font-['Microgramma'] mb-2",
          subtitle: "text-[11px] leading-[1] font-bold !text-[#DBCCDE]",
        },
      },
      event: {
        title: "text-[14px] font-bold leading-[18px] text-black",
        subtitle: "text-[14px] leading-[18px] text-black",
      },
      shop: {
        title: "font-['Microgramma'] uppercase text-[#000000] text-[20px] leading-6",
        text: "text-[14px] leading-[18px] text-black",
        customShopImage: "/assets/customizations/ikigai/img_shop.png",
      },
    },
    announcements: {
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[57px]",
      header: "font-['Microgramma'] uppercase text-black text-[32px] leading-[32px] ",
      title: "font-['Microgramma'] uppercase text-black text-[24px] leading-6 pb-2",
      description: "text-[11px] leading-[1] font-bold !text-[#DBCCDE]",
    },
    announcement: {
      likeCount: "",
      commentCount: "",
      emptyOrLoadingState: "",
      created: "",
      container: "mb-16 p-11 pb-8 space-y-[23px]",
      title: "font-['Microgramma'] uppercase text-black text-[24px] leading-6 pb-2",
      description: "text-[11px] leading-[1] font-bold !text-[#DBCCDE]",
      commentIconColor: "",
      likeIconColor: "",
    },
    event: {
      emptyOrLoadingState: "",
      sectionTitle: "font-['Microgramma'] uppercase text-black text-[24px] leading-8",
      sectionSubtitle: "text-[14px] leading-[18px] font-bold text-black",
      text: "text-[14px] leading-[18px] text-black ",
      separator: "border-b border-[#7659BA]",
      blockContainer: "",
      header: "",
      container: "",
      map: {
        pin: "",
        border: "",
        pinColor: "#7659BA",
        strokeColor: "border-[#7659BA]",
      },
    },
    eventTickets: {
      container: "",
      separator: "",
      event: {
        title: "font-['Microgramma'] uppercase text-black text-[24px] leading-8",
        subtitle: "text-[14px] leading-[18px] font-bold text-black",
      },
      ticket: {
        counterContainer: "",
        title: "text-[20px] leading-5 font-['Microgramma'] text-black uppercase",
        description: "text-[16px] leading-[16px] font-['Microgramma']",
        text: "text-[14px] leading-[18px] text-black",
        price: "text-[20px] leading-5 font-['Microgramma'] text-black",
        quantity: "text-[16px] leading-5 font-bold text-black",
      },
    },
  },
}

export default ikigai
